var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3B3B3B",
    strokeWidth: 2,
    d: "M10.667.333c0 .495.488 1.234.983 1.854a8.7 8.7 0 0 0 2.267 2.03c.654.4 1.446.783 2.083.783m0 0c-.637 0-1.43.383-2.083.783a8.8 8.8 0 0 0-2.267 2.03c-.495.62-.983 1.36-.983 1.854M16 5H0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.815d6b3c7a9a833cab2182bb464e4442.svg";
export { ForwardRef as ReactComponent };